// Telecare's main line. Specialties have no contact details of their own yet; when they do,
// the booking pages should take them from the specialty instead of this.
export const TELECARE_PHONE = '03 9034 9950';
export const TELECARE_PHONE_HREF = 'tel:+61390349950';
